import type { FC } from 'react';
import { TextInput } from 'flowbite-react';

interface AgeRangeValue {
  min: number;
  max: number;
}

interface AgeRangeInputProps {
  value: AgeRangeValue | number | null;
  onChange: (val: AgeRangeValue | null) => void;
  disabled?: boolean;
}

export const AgeRangeInput: FC<AgeRangeInputProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const minVal =
    value && typeof value === 'object' && 'min' in value ? value.min : '';
  const maxVal =
    value && typeof value === 'object' && 'max' in value ? value.max : '';

  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const newMin = raw === '' ? 0 : Number(raw);
    const currMax = typeof maxVal === 'number' ? maxVal : 100;
    onChange({ min: newMin, max: currMax });
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const currMin = typeof minVal === 'number' ? minVal : 0;
    const newMax = raw === '' ? 100 : Number(raw);
    onChange({ min: currMin, max: newMax });
  };

  return (
    <div className="flex items-center gap-1.5">
      <div className="w-20">
        <TextInput
          type="number"
          min={0}
          max={120}
          placeholder="Von"
          value={minVal}
          onChange={handleMinChange}
          disabled={disabled}
          sizing="sm"
          className="sentry-unmask"
        />
      </div>
      <span className="text-xs font-medium text-gray-500 dark:text-gray-400">
        bis
      </span>
      <div className="w-20">
        <TextInput
          type="number"
          min={0}
          max={120}
          placeholder="Bis"
          value={maxVal}
          onChange={handleMaxChange}
          disabled={disabled}
          sizing="sm"
          className="sentry-unmask"
        />
      </div>
      <span className="text-xs text-gray-500 dark:text-gray-400">Jahre</span>
    </div>
  );
};
